import { create } from "zustand";
import { TeacherPresence } from "@/harness/harness.types";

interface UiState {
  teacherPresence: TeacherPresence;
  sidebarOpen: boolean;
  setTeacherPresence: (p: TeacherPresence) => void;
  toggleSidebar: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  teacherPresence: "idle",
  sidebarOpen: false,
  setTeacherPresence: (teacherPresence) => set({ teacherPresence }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
}));
